
import { Component, Vue, Mixins, Prop } from 'vue-property-decorator'
import Chart from '../../mixins/Chart.vue'
import ChartJS, { ChartOptions } from 'chart.js'
import { ElementPoint } from '../../@types/DatasetController'

// @ts-ignore
const TextElement = ChartJS.DatasetController.extend({
  initialize({ _chart, _datasetIndex }) {
    this.chart = _chart
    this.datasetIndex = _datasetIndex
    this.value = this.chart.data.datasets[this.datasetIndex].label
    this.grid = this.makeGrid()
    this._meta = {
      controller: this
    }
  },
  makeGrid() {
    const { length } = this.chart.data.datasets
    const width = this.chart.canvas.width / length / devicePixelRatio
    const height = this.chart.canvas.height / devicePixelRatio
    const x1 = width * this.datasetIndex
    const x2 = x1 + width
    const y1 = 0
    const y2 = height

    return {
      x1,
      x2,
      y1,
      y2,
      width,
      height
    }
  },

  transition() {},

  draw() {
    const ctx: CanvasRenderingContext2D = this.chart.ctx
    ctx.font = '2rem Poppins'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'bottom'
    ctx.fillText(this.value, this.grid.x1 + this.grid.width / 2, this.grid.y2)
  }
})
// @ts-ignore
const BubbleElement = ChartJS.Element.extend({
  initialize({ _chart, _datasetIndex, _index }) {
    this.chart = _chart
    this.datasetIndex = _datasetIndex
    this.value = this.chart.data.datasets[this.datasetIndex].data[_index]
  },
  draw() {
    const ctx: CanvasRenderingContext2D = this.chart.ctx
    ctx.fillRect(10, 10, 100, 100)
  }
})

//@ts-ignore
ChartJS.controllers.boolean = ChartJS.DatasetController.extend({
  datasetElementType: TextElement,
  dataElementType: BubbleElement,
  transition() {},
  update() {}
})

ChartJS.defaults._set('boolean', <ChartOptions>{
  legend: {
    display: false
  },
  scales: {
    display: false,
    xAxes: [
      {
        display: false
      }
    ],
    yAxes: [
      {
        display: false
      }
    ]
  }
})

console.log(ChartJS.defaults)

@Component
export default class Boolean extends Mixins(Chart) {
  /**
   * Chart type.
   */
  public readonly chartType: string = 'boolean'
}
